import React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInboxSidebarCounts as GetInboxSidebarCountsQuery,
    GetInboxSidebarCountsVariables as GetInboxSidebarCountsQueryVariables,
} from 'nutshell-graphql-types';

import GET_SIDEBAR_COUNTS from '../queries/get-inbox-sidebar-counts.graphql';

const POLL_INTERVAL_MILLISECONDS = 5000; // 5 seconds

export const useGetInboxSidebarCounts = (input: {assignees: string[]; inboxUserIds: string[]}) => {
    const {
        data,
        error,
        loading: isLoading,
        startPolling,
        stopPolling,
        refetch,
    } = useQuery<GetInboxSidebarCountsQuery, GetInboxSidebarCountsQueryVariables>(
        GET_SIDEBAR_COUNTS,
        {
            variables: {...input},
            fetchPolicy: 'cache-and-network',
        }
    );

    const inboxThreadCounts = data ? data.inboxThreadCounts : null;

    React.useEffect(() => {
        if (inboxThreadCounts) {
            startPolling(POLL_INTERVAL_MILLISECONDS);
        }

        return () => stopPolling();
    }, [inboxThreadCounts, startPolling, stopPolling]);

    return {
        inboxSidebarCounts: inboxThreadCounts,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
